import type {
  ColumnSeparator,
  FileEncoding,
  MarkerSetupType,
  MultipartUploadedFile,
  OptionItemType,
} from '@core/core/types'

import type { MarkersParsedData } from '../markersHelpers'

export type SetupProps = {
  file: MultipartUploadedFile
  parsedData: MarkersParsedData
  settings: MarkerSetupType
  updateFileConfig: (fileId: string, setupContent: MarkerSetupType, shouldPersist?: boolean) => void
}

export const encodingOptions: OptionItemType<FileEncoding>[] = [
  { label: 'ANSI', name: 'cp1251' },
  { label: 'UTF-8', name: 'utf8' },
  { label: 'UTF-16', name: 'utf16' },
]

export const separatorOptions: OptionItemType<ColumnSeparator>[] = [
  { label: 'Пробел', name: 'space' },
  { label: 'Табуляция', name: 'tab' },
  { label: 'Запятая', name: 'comma' },
  { label: 'Точка с запятой', name: 'semicolon' },
  { label: 'Двоеточие', name: 'colon' },
  { label: 'Черта', name: 'slash' },
]

export type AttributesTableProps = {
  settings: MarkerSetupType
  contentRow: string[]
  update: (value: Partial<MarkerSetupType>) => void
}
